import constants from 'app/constants'
import useLogger from 'lib/util/useLogger'

const debug = useLogger('User Data', 'mistyrose')

/**
 * Parse the user owned avatars
 *
 * @param {object} props - the input props
 * @returns {Array} the parsed avatars
 */
export default function parseUserAvatars (props) {
  const { avatars, categoryConfig, elementsKeys } = props

  return avatars
    .reduce((avatarRes, avatar) => {
      const defaultAvatar = {
        type: 'citizen',
        gender: 'male',
        style: 'puks',
        items: [],
        visibleLayers: [],
        url: '',
        didMatch: false
      }
      let order = []

      const parsedAvatar = avatar.items.reduce(
        (res, itemId) => {
          const match = elementsKeys[itemId]

          if (match) {
            if (match.layer === 'face') {
              // Get style
              res.type = (match.type || res.type).toLowerCase()
              res.gender = (match.gender[0] || res.gender).toLowerCase()
              res.style = (match.style[0] || res.style).toLowerCase()
              res.didMatch = true

              if (match.layer_order && match.layer_order.length) {
                // Found the layer order (should always be on face)
                order = match.layer_order
              }
            }

            res.items.push({
              ...match,
              url: `/account/wardrobe/${match.id}`,
              layerLabel: categoryConfig?.[match?.layer]?.label || 'Base'
            })
          } else {
            debug.error('Could not match item with ID:', itemId)
          }

          return res
        },
        { ...defaultAvatar }
      )

      if (!parsedAvatar.didMatch) {
        debug.log('Failed to match avatar details for avatar:', avatar)

        return avatarRes
      }

      if (!parsedAvatar.items.length) {
        // The avatar has no items at all, which means something is wrong.
        // (Because it should at least contain base layers.) Do not push
        // it to results data
        return avatarRes
      }

      // Sort the items into their appearance order, to avoid having
      // to do it later
      parsedAvatar.items = order.reduce((res, layer) => {
        const match = parsedAvatar.items.find(item => item?.layer === layer)

        if (match) {
          res.push(match)
        }

        return res
      }, [])

      const hiddenLayerIds = [
        ...new Set(
          parsedAvatar.items.flatMap(accessory => accessory.hides || [])
        )
      ]

      // Apply the visible layers by filtering out hidden layers
      parsedAvatar.visibleLayers = parsedAvatar.items.filter(
        accessory => !hiddenLayerIds.includes(accessory.layer)
      )

      const tokenUrl = `${constants.COLLECTION_URL}/${constants.CONTRACTS.AvatarCollection.address}:${avatar?.id}`

      avatarRes.push({
        id: avatar?.id ?? 0,
        ...parsedAvatar,
        url: `/account/avatars/${avatar?.id ?? 0}`,
        tokenUrl
      })

      return avatarRes
    }, [])
    .sort((a, b) => b.id - a.id)
}
